export * from './normalize-sfcc-locale';
